module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-26-74f08647cc7338be1300dc47e17b82cd.jpg";